import { memo, useCallback, useMemo, useRef } from 'react'
import './index.scss'
import { useTranslation } from 'react-i18next'
import { useSidebar } from '../../../../hooks/useSidebar'
import FlotiMap from '../../../../components/FlotiMap'
import { useMap } from '../../../../hooks/useMap'
import { Point } from 'ol/geom'
import { PROJECTION_TYPE } from '../../../../components/FlotiMap/context/reducer'

type FuelDevCol = {
  data: {
    site_name?: string
    mobile_poslat?: number
    mobile_poslon?: number
    station_poslat?: number
    station_poslon?: number
    station_geom?: number
    purchase_date?: string
    transaction_id?: string
  }
}

const FuelDeviationColumn = memo(({ data }: FuelDevCol) => {
  const mapRef = useRef()
  const { t } = useTranslation()
  const { updateSidebar } = useSidebar()
  const { radiansToDegrees } = useMap()

  const polygon = useMemo(() => {
    const lookup = {}
    if (data.station_geom?.length) {
      lookup.label = data.site_name
      lookup.polyshape = data.station_geom
    }
    return lookup
  }, [data.station_geom])

  const transformCenter = useCallback((centerArr, ref) => {
    const projection = ref?.current.getProjection()
    const lat = radiansToDegrees(centerArr[1])
    const lon = radiansToDegrees(centerArr[0])
    const center = new Point([lon, lat]).transform(PROJECTION_TYPE, projection)
    return center.getFlatCoordinates()
  }, [radiansToDegrees])

  const openMapSidebar = useCallback(async () => {
    await updateSidebar({
      isOpen: true,
      header: t('Deviation recorded'),
      content: (
        <FlotiMap ref={mapRef} readonly={false} />
      )
    })

    mapRef.current.setPolyshapes([polygon])
    mapRef.current.setPoints([{
      lat: data.mobile_poslat,
      lon: data.mobile_poslon,
      date: data.purchase_date,
      id: data.transaction_id
    }])

    const center = transformCenter([data.station_poslon, data.station_poslat], mapRef)
    mapRef.current.setMapSettings({
      zoom: 14,
      center
    })
  }, [data, updateSidebar, mapRef, polygon, transformCenter, t])

  return (
    <div
      className="FuelDeviationColumn"
      role="button"
      tabIndex={0}
      onClick={() => openMapSidebar()}
    >
      {t('Yes')}
    </div>
  )
})

export default FuelDeviationColumn
